import React, { useState,useEffect } from 'react';
import { Badge, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { DERSystemDevice, optionMapper, optionValueMapper } from '../constant';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { DER_KEY, ValidationSchema, initialValues } from './helpers';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import EditButton from '../Grid/EditButton';
import DeleteBtn from '../Grid/DeleteButton';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectData, resetProjectStateReducer } from '../../app/projects/createProjectSlice';
import { resetCityStateReducer } from '../../app/contact/contactSlice';
const SystemInfo = (props) => {
  const { setSection, pageType } = props;

  const {
    register,
    watch,
    handleSubmit,
    trigger,
    setValue,
    getValues,
    reset,
    clearErrors,
    formState: { errors, isValid, isValidating },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(ValidationSchema),
    defaultValues: initialValues,
  });
  const [statusModal, showStatusModal] = useState({ show: false });
  const [editId, setEditId] = useState('');
  const [DERlist, setDERlist] = useState([]);
  const [eType, setEtype] = useState([]);
  const [esd, setEsd] = useState([]);

  const deviceField = register(DER_KEY.DEVICE);
  const energyDfiled = register(DER_KEY.ENERGY);
  const esdFiled = register(DER_KEY.ESD_G);
  const capacityField = register(DER_KEY.CAPACITY);

  const dispatch = useDispatch();
  const projectData = useSelector(getProjectData);

  useEffect(() => {
    if (projectData?.reponseMessage === 'Submitted' && projectData?.appNb) {
      showStatusModal({ show: true, state: 'success' });
    }
  }, [projectData]);

  useEffect(()=>{
    setSection(null,DERlist);
  },[DERlist])

  
  const resetAppForm = () => {
    props.resetAppForm();
    dispatch(resetCityStateReducer());
    dispatch(resetProjectStateReducer());
    showStatusModal({ show: false });
  };

  const renderError = (key) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid">
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );

  const onDeviceTypeChange = (e) => {
    setValue(DER_KEY.ESD_G, '');
    setValue(DER_KEY.ENERGY, '');
    setEsd([]);
    const selectedDevice = DERSystemDevice.filter(
      (device) => device.value === e.target.value
    );
    setEtype(selectedDevice[0]?.eType || []);
  };

  const onEnergyTypeChange = (e) => {
    setValue(DER_KEY.ESD_G, '');
    const selectedEtype = eType.filter((er) => er.value === e.target.value);
    setEsd(selectedEtype[0]?.esd || []);
  };

  const resetForm = () => {
    reset();
    setEditId('');
    setEsd([]);
    setEtype([]);
  };

  const submitEnrollment =()=>{
    props.createOrSaveProject('Submit')
  }

  const onAddSaveDevice = (data) => {
    if (editId) {
      const dItem = DERlist.find((x) => x.id === editId);
      const dIndex = DERlist.indexOf(dItem);
      if (dIndex >= 0) {
        const updateItem = { ...dItem, ...data };
        const newState = [...DERlist];
        newState[dIndex] = updateItem;
        setDERlist(newState);
      }
    } else {
      const uniqueID = () => Math.floor(Math.random() * Date.now());
      const id = uniqueID();
      setDERlist([...DERlist, { id, ...data }]);
    }
    resetForm();
  };

  const onEdit = async (id) => {
    if (id) {
      setEditId(id);
      const edititem = DERlist.filter((el) => el.id === id);
      setValue(DER_KEY.DEVICE, edititem[0]?.[DER_KEY.DEVICE]);
      setValue(DER_KEY.CAPACITY, edititem[0]?.[DER_KEY.CAPACITY]);
      const eTypeList = DERSystemDevice.filter(
        (device) => device.value === edititem[0]?.[DER_KEY.DEVICE]
      );
      await setEtype(eTypeList[0]?.eType || []);
      const selectedEtype = eTypeList[0]?.eType.filter(
        (er) => er.value === edititem[0]?.[DER_KEY.ENERGY]
      );
      await setEsd(selectedEtype[0]?.esd || []);
      setValue(DER_KEY.ENERGY, edititem[0]?.[DER_KEY.ENERGY]);

      setValue(DER_KEY.ESD_G, edititem[0]?.[DER_KEY.ESD_G]);
    }
  };

  const onDelete = (id) => {
    const newList = DERlist.filter((el) => el.id !== id);
    setDERlist(newList);
  };

  const calculateSumCap = () => {
    return DERlist?.length > 0
      ? DERlist?.reduce((a, v) => a + Number(v?.[DER_KEY.CAPACITY]), 0)
      : 0;
  };

  const RenderDERList = () => {
    return DERlist?.length ? (
      <>
        <Badge style={{ float: 'right' }} pill bg="warning" text="dark">
          Total capacity: {calculateSumCap()}
        </Badge>
        <Table>
          <tbody>
            <tr>
              <th>Device Type</th>
              <th>Energy Type</th>
              <th>ESD/ Gen</th>
              <th>Capacity</th>
              <th></th>
              <th></th>
            </tr>
            {DERlist?.map((item) => (
              <tr>
                <td>{item?.[DER_KEY.DEVICE]}</td>
                <td>{item?.[DER_KEY.ENERGY]}</td>
                <td>{item?.[DER_KEY.ESD_G]}</td>
                <td>{item?.[DER_KEY.CAPACITY]}</td>
                <td>
                  <EditButton onClick={() => onEdit(item.id)} />
                </td>
                <td>
                  <DeleteBtn
                    data={{ appStatusGroup: 'NA' }}
                    onClick={() => onDelete(item.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    ) : (
      <div style={{ textAlign: 'center' }}>No Device Added</div>
    );
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onAddSaveDevice)}>
        <Row>
          <Col>
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Devices
            </Form.Text>
            <Form.Select
              size="sm"
              aria-label="device"
              {...deviceField}
              onChange={onDeviceTypeChange}
              isInvalid={errors[DER_KEY.DEVICE]}
            >
              <option value="">Please select</option>
              {optionValueMapper(DERSystemDevice)}
            </Form.Select>
            {renderError(DER_KEY.DEVICE)}
          </Col>
          <Col>
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Energy Type
            </Form.Text>
            <Form.Select
              size="sm"
              aria-label="energy"
              {...energyDfiled}
              onChange={onEnergyTypeChange}
              isInvalid={errors[DER_KEY.ENERGY]}
            >
              <option value="">Please select</option>
              {optionValueMapper(eType)}
            </Form.Select>
            {renderError(DER_KEY.ENERGY)}
          </Col>
          <Col>
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Energy Storage Device/Generator
            </Form.Text>
            <Form.Select
              size="sm"
              aria-label="esdg"
              {...esdFiled}
              isInvalid={errors[DER_KEY.ESD_G]}
            >
              <option value="">Please select</option>
              {optionMapper(esd)}
            </Form.Select>
            {renderError(DER_KEY.ESD_G)}
          </Col>
          <Col>
            <Form.Group controlId="capacity">
              <Form.Text size="sm" style={{ margin: '2px' }}>
                Proposed capacity
              </Form.Text>
              <Form.Control
                type="number"
                placeholder="Capacity"
                {...capacityField}
                isInvalid={errors[DER_KEY.CAPACITY]}
              />
              {renderError(DER_KEY.CAPACITY)}
            </Form.Group>
          </Col>
        </Row>
        <StyledButton type="submit" btnType="primary" variant="dark" size="md">
          {editId ? 'Save' : 'Add Device'}
        </StyledButton>
        <StyledButton
          btnType="secondary"
          variant="dark"
          size="md"
          onClick={resetForm}
        >
          {editId ? 'Cancel' : 'Reset'}
        </StyledButton>
      </Form>
      <RenderDERList />
      {pageType !== 'view' && (
        <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => {
              setSection(false,[]);
            }}
          >
            Back
          </StyledButton>
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
            disabled={!Boolean(DERlist.length)}
            onClick={submitEnrollment}
          >
            Submit
          </StyledButton>
        </ButtonContainer>
      )}
        <Modal
        centered
        size="lg"
        onShow={() => {}}
        onExited={() => {}}
        show={statusModal?.show}
        onHide={() => {
          resetAppForm();
        }}
      >
        <Modal.Header closeButton>
          {statusModal?.state === 'success' && (
            <Modal.Title>{`Pre Application Request Submitted-Application No: ${projectData?.appNb}`}</Modal.Title>
          )}
          {statusModal?.state === 'failed' && (
            <Modal.Title>{`Error Occured during the process`}</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {statusModal?.state === 'success' && (
            <h5 className="text-center">
              {`Thankyou for submitting Pre Application  Request`}
            </h5>
          )}
          {statusModal?.state === 'failed' && (
            <h5 className="text-center">
              {`Please contact admin or try again later`}
            </h5>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SystemInfo;
